module.exports = __webpack_public_path__ + "img/ExhibitionView1.90842b7a.jpg";